import { Image } from 'antd';
import ActionHeader from '../../../components/actionHeader';
import Page from '../../../components/page';

const DiagnoseInsight = () => {
  return (
    <Page header={<ActionHeader title="Diagnosis Insight (Coming soon)" />}>
      <div style={{ padding: 24 }}>
        <Image
          src="/diagnose_insight.png"
          preview={false}
          style={{ width: '100%' }}
        ></Image>
      </div>
    </Page>
  );
};

export default DiagnoseInsight;
